import styled from '@emotion/styled';
import SubNavigation from 'components/Navigation/SubNavigation';
import { CardBasic } from 'components/Card/Card';
import css from '@emotion/css';

export const StyledSubNavigation = styled(SubNavigation)`
  && a {
    padding-bottom: 10px !important;
  }
`;

export const PageWrapper = styled.div`
  margin: 0 auto;
  width: 100%;
  position: relative;
  max-width: 1372px;
`;

export const ContentCard = styled(CardBasic)<{
  loadable?: boolean;
  padding?: number;
  minWidth?: number;
}>`
  ${({ loadable }) =>
    loadable
      ? css`
          position: relative;
          overflow: hidden;
        `
      : ''}
  padding: ${({ padding }) => padding ?? 20}px;
  ${({ minWidth }) =>
    minWidth
      ? css`
          min-width: ${minWidth}px;
        `
      : ''}
`;
